module.exports = __webpack_public_path__ + "images/img-1bMjCV1.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/2.png
// module id = 2338
// module chunks = 0